import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom"; // 추가
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingMenu from "./components/FloatingMenu";
import "./style.css";

// 각 페이지 컴포넌트 import
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Sns from "./pages/Sns";
import Schedule from "./pages/Schedule";
import BoardNew from "./pages/BoardNew";
import BoardDetail from "./pages/BoardDetail";
import BoardEdit from "./pages/BoardEdit";
import LocationPage from "./pages/LocationPage";
import InquiryForm from "./pages/InquiryForm"; // 일반 사용자용 문의 작성
import AdminInquiryList from "./pages/AdminInquiryList"; // 관리자용 문의 확인
import AdminInquiryDetail from "./pages/AdminInquiryDetail";
import NaverLogin from "./components/NaverLogin"; // 네이버 로그인
import NaverCallback from "./naver/callback/NaverCallback"; // 콜백

function AppWrapper() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="flex flex-col min-h-[120vh]">
      <Header />
      <main className={`flex-grow ${!isHome ? "pt-24" : ""}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/sns" element={<Sns />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/board/:id" element={<BoardDetail />} />
          <Route path="/location" element={<LocationPage />} />
          <Route path="/inquiry" element={<InquiryForm />} />
          <Route path="/admin/inquiries" element={<AdminInquiryList />} />
          <Route path="/admin/inquiries/:id" element={<AdminInquiryDetail />} />
          <Route path="/board/new" element={<BoardNew />} />
          <Route path="/board/edit/:id" element={<BoardEdit />} />
          <Route path="/naver/login" element={<NaverLogin />} />
          <Route path="/naver/callback" element={<NaverCallback />} />
        </Routes>
      </main>
      <Footer />
      <FloatingMenu />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
